// src/api/checkout/chargesdetailApi.js
import axios from "axios";
import { ITEMAVILABLE } from "../index";

export const itemAvailableApi = (postData) => {
  return axios.post(ITEMAVILABLE, postData);
};
